import {BankAddressDto} from "./bank-address.dto";
import {isDefined, isTrue, notDefined} from "../../libs/utils/epic.utils";
import {PaymentMethod} from "../../libs/enum/payment-method";

export class DocumentPaymentEntryDto {

  public readonly id!: string;
  public readonly amount!: number;
  public readonly method!: PaymentMethod;
  public readonly date!: Date;
  public bankAddressId: string | undefined;
  public bankAddress: BankAddressDto | undefined;
  public readonly editable!: boolean;
  public remainingAmountActon: PaymentMethod | undefined;

  // Transient: is set for Table-Formatter e.g., AbstractTable.formatContent
  public currencyCode: string | undefined;

  constructor(init?: Partial<DocumentPaymentEntryDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.date)) {
      this.date = new Date(init.date);
    }
    if (isDefined(init?.bankAddress)) {
      this.bankAddress = new BankAddressDto(init.bankAddress);
    }
  }

  public isEditable(): boolean {
    return notDefined(this.editable) || isTrue(this.editable);
  }
}
